ALLOWED_CONTROLLER = 'send_lcc'
ALLOWED_ACTIONS = ['select_card']

ready = ->
  return unless continueIfAllowed(ALLOWED_CONTROLLER, ALLOWED_ACTIONS)
  selectCardCheckbox = $("input[data-selector='select_card'][type='checkbox']")
  selectCardRadioButton = $("input[data-selector='select_card'][type='radio']")

  selectCardCheckbox.on "change", ->
    selectCardRadioButton.prop('checked', false)

  selectCardRadioButton.on "change", ->
    selectCardCheckbox.prop('checked', false)


$(document).ready(ready)
$(document).on('turbo:load', ready)
